// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessEvChargeSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.021 6.375C3.021 4.511 4.5 3 6.321 3h4.4c1.823 0 3.3 1.511 3.3 3.375v5.49h.98c1.1 0 2 .9 2 2v4.5c0 .55.45 1 1 1s1-.45 1-1V9.453a.15.15 0 0 0-.045-.106l-.297-.298a.15.15 0 0 0-.106-.043L17.023 9a.15.15 0 0 1-.106-.044l-1.25-1.25c-.236-.236-.236-.707 0-.938l-.026-.039a.503.503 0 0 0-.07-.085l-.74-.715a.15.15 0 0 1 0-.212l.26-.26a.15.15 0 0 1 .212 0l.731.731a.15.15 0 0 0 .212 0l.73-.73a.15.15 0 0 0 0-.213l-.73-.73a.15.15 0 0 1 0-.213l.26-.26a.15.15 0 0 1 .212 0l.732.729c.059.059.154.056.227.016.248-.14.618-.11.818.09l1.252 1.253a.15.15 0 0 1 .044.106l.002 1.528c0 .04.016.078.044.106l.517.516a.5.5 0 0 1 .146.354v9.624a2.5 2.5 0 0 1-5 0v-4.85a.15.15 0 0 0-.15-.15h-1.328v7.072c0 .311-.247.563-.55.563h-9.9a.556.556 0 0 1-.55-.563zm3.017 6.678c-.077.238.123.477.4.477h.99l-.145 2.074c-.026.374.513.544.755.238l2.906-3.667c.195-.246-.002-.587-.34-.587h-.789l1.012-2.067c.12-.246-.081-.521-.381-.521H7.673a.413.413 0 0 0-.4.268z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessEvChargeSolid;
